"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.colorDefaults = exports.getThemeColorFromAlias = exports.ColorNames = void 0;
var ColorNames;
(function (ColorNames) {
    ColorNames["Hannibal"] = "Hannibal";
    ColorNames["Baracus"] = "Baracus";
    ColorNames["Faceman"] = "Faceman";
    ColorNames["Murdock"] = "Murdock";
    ColorNames["Grey"] = "Grey";
    ColorNames["Red"] = "Red";
    ColorNames["Green"] = "Green";
})(ColorNames = exports.ColorNames || (exports.ColorNames = {}));
var getThemeColorFromAlias = function (alias, themeColors) {
    if (alias === 'inherit')
        return alias;
    var _a = alias.split('@'), colorName = _a[0], level = _a[1];
    if (colorName in themeColors) {
        var color = themeColors[colorName];
        return level in color ? color[Number(level)] : undefined;
    }
    return undefined;
};
exports.getThemeColorFromAlias = getThemeColorFromAlias;
exports.colorDefaults = (_a = {},
    _a[ColorNames.Hannibal] = '#7000E3',
    _a[ColorNames.Baracus] = '#FF7A00',
    _a[ColorNames.Faceman] = '#FF4AC1',
    _a[ColorNames.Murdock] = '#01DDF6',
    _a[ColorNames.Green] = '#70C93C',
    _a[ColorNames.Red] = '#F63041',
    _a);
exports.theme = {
    colors: (_b = {},
        _b[ColorNames.Hannibal] = {
            100: '#FBF7FF',
            200: '#E8D1FF',
            300: '#CE9FFF',
            400: '#A54CFF',
            500: '#9024FF',
            600: '#7000E3',
            700: '#5400AA',
            800: '#3A0A6B',
            900: '#26014D',
            1000: '#090012',
            default: exports.colorDefaults[ColorNames.Hannibal],
            hover: '#6500CC',
            active: '#5D00BD',
        },
        _b[ColorNames.Baracus] = {
            100: '#FFFBF8',
            200: '#FFE9D4',
            300: '#FFD8AB',
            400: '#FFB156',
            500: '#FF8D24',
            600: '#FF7A00',
            700: '#E15100',
            800: '#972C0B',
            900: '#771C00',
            1000: '#311700',
            default: exports.colorDefaults.Baracus,
            hover: '#F07200',
        },
        _b[ColorNames.Faceman] = {
            100: '#FFF4FB',
            200: '#FFE5F6',
            300: '#FFC3EB',
            400: '#FF93DA',
            500: '#FE6BCC',
            600: '#FF4AC1',
            700: '#FF0FAD',
            800: '#B60C7C',
            900: '#800054',
            1000: '#370024',
            default: exports.colorDefaults.Faceman,
            hover: '#F046B5',
        },
        _b[ColorNames.Murdock] = {
            100: '#F5FEFF',
            200: '#E5FCFF',
            300: '#C4F9FF',
            400: '#93F3FF',
            500: '#6BEFFF',
            600: '#01DDF6',
            700: '#00C6DD',
            800: '#00B1C6',
            900: '#007C8A',
            1000: '#00262B',
            default: exports.colorDefaults.Murdock,
            hover: '#01D0E8',
        },
        _b[ColorNames.Grey] = {
            0: '#FFFFFF',
            100: '#F9FAFC',
            200: '#EBECEF',
            300: '#D3D6DC',
            400: '#B5B8BF',
            500: '#6E7177',
            600: '#4C4D50',
            700: '#35373A',
            800: '#202020',
            900: '#000000',
            1000: '#000000',
            hover: '#E7E8EB',
            active: '#E4E5E8',
        },
        _b[ColorNames.Red] = {
            100: '#FFF7F8',
            200: '#FDE7E9',
            300: '#FAC7CB',
            400: '#F69DA5',
            500: '#F37883',
            600: '#F63041',
            700: '#DC0A1C',
            800: '#BF0818',
            900: '#840611',
            1000: '#3B0307',
            default: exports.colorDefaults.Red,
            hover: '#ED2E3F',
            active: '#E82D3E',
        },
        _b[ColorNames.Green] = {
            100: '#F6FCF3',
            200: '#DCF2CF',
            300: '#C5EBB0',
            400: '#B0E193',
            500: '#98D873',
            600: '#70C93C',
            700: '#62B432',
            800: '#559C2B',
            900: '#3B6C1E',
            1000: '#1A300D',
            default: exports.colorDefaults.Green,
            hover: '#6CC23A',
            active: '#69BD38',
        },
        _b),
    gutters: {
        xs: 24,
        sm: 16,
        md: 16,
        lg: 16,
        xl: 16,
        xxl: 16,
    },
    breakpoints: {
        sm: 1024,
        md: 1280,
        lg: 1366,
        xl: 1440,
        xxl: 1920,
    },
    columns: {
        xs: 4,
        sm: 6,
        md: 6,
        lg: 12,
        xl: 12,
        xxl: 15,
    },
    borderRadius: {
        xs: 2,
        sm: 4,
        md: 8,
        lg: 12,
    },
    margins: {
        none: 0,
        xxs: 8,
        xs: 12,
        sm: 16,
        md: 24,
        lg: 32,
        xl: 40,
        xxl: 64,
    },
};
//# sourceMappingURL=index.js.map